// API Keys
export const RECAPTCHA_SITE_KEY = '6LdYCqUdAAAAAEvvEVRTETff1QC42u5YgR2ZGd4M';

// Width breakpoints
export const SM_BREAKPOINT_PIXELS = 576;
export const MD_BREAKPOINT_PIXELS = 768;
export const LG_BREAKPOINT_PIXELS = 992;

// Classes
export const _TAG_CLASS_ID = '5f469e0a8e252233d9b043b5';
export const SERVICE_CLASS_ID = '5d66ed07e7c98a556a499a36';
export const TICKET_CLASS_ID = '5d446dfc62d9656275a47d69';
export const COMPONENT_CLASS_ID = '64414f5f50c81b0fadba1b5b';
export const CATALOG_CLASS_ID = '5ca3bca7d18bdb280c9c6c2c';
export const CATEGORY_CLASS_ID = '5ca3bd5dd18bdb280c9d28af';

// Users
export const SYS_USER_ID = '000000000002000000000001';
export const ADMIN_USER_ID = '000000000000000000000009';
export const GUEST_USER_ID = '5cbdb800dbab3e44afeae867';

// Portal display modes
export const VIEW_MODE_CARD_ID = '5da0749eb347993b5e58b5d6';
export const VIEW_MODE_LEAFS_ID = '5da074a9b347993b5e58b5e5';
export const VIEW_MODE_LIST_ID = '5e6a85eaf631ec731725b16e';
export const VIEW_MODE_TREE_ID = '5da07482b347993b5e58b5c7';

// Attendance actions
export const ANSWER_ACTION_ID = '5db860ba4591c909342c5177';
export const CLOSE_ACTION_ID = '5e2615bb8cd2746d93c5580f';
export const RATE_ACTION_ID = '5db860e94591c909342c518b';
export const CHANGE_RATING_ACTION_ID = '67d879dee9eed232b490e6c7';

// NPS avaliations type
export const PROMOTER_RATING_TYPE_ID = '5da7544bdfa90c763d8582a7';
export const NEUTRAL_RATING_TYPE_ID = '5da7543fdfa90c763d8581fb';
export const DETRACTOR_RATING_TYPE_ID = '5da75433dfa90c763d857ded';

// Map of service status IDs to their corresponding status classes.
export const STATUS_CLASS_SERVICE = {
  '5cae4264a50bfe4c0d3f6eff': {
    className: 'sy-sd-tag closed',
    style: {
      '--sy-tag-background-color': '#ebebeb',
      '--sy-tag-color': '#575757',
    },
  },
  '5cc01d8521dc12734173e807': {
    className: 'sy-sd-tag cancelled',
    style: {
      '--sy-tag-background-color': '#f6d7d7',
      '--sy-tag-color': '#7f0923',
    },
  },
  '5cae41fea50bfe4c0d3f6ee3': {
    className: 'sy-sd-tag awaiting',
    style: {
      '--sy-tag-background-color': '#e8fcff',
      '--sy-tag-color': '#345f64',
    },
  },
  '5cae4247a50bfe4c0d3f6ef1': {
    className: 'sy-sd-tag resolved',
    style: {
      '--sy-tag-background-color': '#dcf8e9',
      '--sy-tag-color': '#0c5c32',
    },
  },
  '5cacdc2fa50bfe4c0d3e5dc0': {
    className: 'sy-sd-tag pending',
    style: {
      '--sy-tag-background-color': '#fff1da',
      '--sy-tag-color': '#943e12',
    },
  },
  '5cae41efa50bfe4c0d3f6ed5': {
    className: 'sy-sd-tag progress',
    style: {
      '--sy-tag-background-color': '#e5f1ff',
      '--sy-tag-color': '#232e86',
    },
  },
  '5cbfff0a21dc12734173ac40': {
    className: 'sy-sd-tag new',
    style: {
      '--sy-tag-background-color': '#2068C7',
      '--sy-tag-color': '#fff',
    },
  },
  '595c20500200000000000004': {
    className: 'sy-sd-tag aborted',
    style: {
      '--sy-tag-background-color': '#ebebeb',
      '--sy-tag-color': '#af0a2f',
    },
  },
  '595c20500200000000000005': {
    className: 'sy-sd-tag error',
    style: {
      '--sy-tag-background-color': '#ebebeb',
      '--sy-tag-color': '#af0a2f',
    },
  },
  '595c20500200000000000002': {
    className: 'sy-sd-tag active',
    style: {
      '--sy-tag-background-color': '#d7edff',
      '--sy-tag-color': '#232e86',
    },
  },
  '595c20500200000000000003': {
    className: 'sy-sd-tag concluded',
    style: {
      '--sy-tag-background-color': '#dcf8e9',
      '--sy-tag-color': '#0c5c32',
    },
  },
  '595c20500200000000000001': {
    className: 'sy-sd-tag waiting',
    style: {
      '--sy-tag-background-color': '#fff1da',
      '--sy-tag-color': '#943e12',
    },
  },
  '595c20500200000000000007': {
    className: 'sy-sd-tag starting',
    style: {
      '--sy-tag-background-color': '#fff1da',
      '--sy-tag-color': '#943e12',
    },
  },
  '595c20500200000000000006': {
    className: 'sy-sd-tag halted',
    style: {
      '--sy-tag-background-color': '#f6d7d7',
      '--sy-tag-color': '#7f0923',
    },
  },
};

export const ACCESSIBILITY_BAR_HEIGHT = 33;
export const NAVBAR_HEIGHT = 72;
export const NAVBAR_MOBILE_HEIGHT = 58;

// Tags
export const TAG_ON_TIME_ID = '5ce58778150308416d0176e1';
export const TAG_ATTENTION_ID = '5ce587a5150308416d017734';
